module.exports = __webpack_public_path__ + "static/media/nmc.8429d203.svg";